import { ROLE_OPTIONS } from "@utils/userFormatters";
import Icon from "./Icon";

export default function AddUserCard({
  form,
  setForm,
  showPassword,
  setShowPassword,
  saving,
  error,
  onCreate,
}) {
  return (
    <div className="rounded-2xl border bg-white overflow-hidden">
      <div className="px-5 py-3 border-b flex items-center justify-between">
        <div className="font-semibold text-slate-900 flex items-center gap-2">
          <span className="p-2 rounded-xl bg-slate-50 border">
            <Icon name="plus" className="w-4 h-4" />
          </span>
          Add a user
        </div>

        <div
          className={`text-xs px-2.5 py-1 rounded-full border ${
            error
              ? "bg-red-50 text-red-800 border-red-200"
              : "bg-emerald-50 text-emerald-800 border-emerald-200"
          }`}
        >
          {error ? error : "Ready to add"}
        </div>
      </div>

      <div className="p-5">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
          <div className="md:col-span-2">
            <label className="block text-xs font-medium text-slate-700 mb-1">
              Email
            </label>
            <input
              className="w-full border rounded-xl px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-sky-200"
              placeholder="name@clinic.com"
              value={form.email}
              onChange={(e) =>
                setForm((p) => ({ ...p, email: e.target.value }))
              }
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">
              Role (required)
            </label>
            <select
              className="w-full border rounded-xl px-3 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-sky-200"
              value={form.role}
              onChange={(e) => setForm((p) => ({ ...p, role: e.target.value }))}
            >
              <option value="" disabled>
                Select a role…
              </option>
              {ROLE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
            <div className="mt-1 text-[11px] text-slate-500">
              Pick Doctor or Staff to continue.
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">
              Password
            </label>
            <div className="relative">
              <input
                className="w-full border rounded-xl px-3 py-2.5 pr-10 focus:outline-none focus:ring-2 focus:ring-sky-200"
                placeholder="Min 8 characters"
                type={showPassword ? "text" : "password"}
                value={form.password}
                onChange={(e) =>
                  setForm((p) => ({ ...p, password: e.target.value }))
                }
              />
              <button
                type="button"
                className="absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-lg hover:bg-slate-50"
                onClick={() => setShowPassword((v) => !v)}
              >
                <Icon
                  name={showPassword ? "eye-off" : "eye"}
                  className="w-4 h-4"
                />
              </button>
            </div>
            <div className="mt-1 text-[11px] text-slate-500">
              Password must include: uppercase, lowercase, number, and symbol
              (min 8 chars).
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">
              Confirm
            </label>
            <input
              className="w-full border rounded-xl px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-sky-200"
              placeholder="Repeat password"
              type={showPassword ? "text" : "password"}
              value={form.confirm_password}
              onChange={(e) =>
                setForm((p) => ({ ...p, confirm_password: e.target.value }))
              }
            />
          </div>
        </div>
        <div className="mt-4 flex flex-col sm:flex-row sm:items-center gap-2">
          <button
            className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-white
                       bg-gradient-to-r from-slate-900 to-slate-800 hover:from-slate-800 hover:to-slate-700
                       shadow-sm disabled:opacity-50"
            disabled={saving || !!error}
            onClick={onCreate}
          >
            <Icon name="plus" className="w-4 h-4" />
            {saving ? "Adding..." : "Add user"}
          </button>
        </div>
      </div>
    </div>
  );
}
